import { HttpService } from "../modules/shared/services/http.service";

const headers = { "Content-Type": "application/json", "x-custom-lang": "en" } as const;

// Stripe Connect Interfaces
export interface StripeAccount {
  id: string;
  chargesEnabled: boolean;
  payoutsEnabled: boolean;
  detailsSubmitted: boolean;
}

export interface CreateConnectedAccountDto {
  email: string;
  country: string;
  type?: "express" | "standard";
}

export interface AccountStatusResponse {
  id: string;
  chargesEnabled: boolean;
  payoutsEnabled: boolean;
  detailsSubmitted: boolean;
}

export interface CreateAccountLinkDto {
  type?: "account_onboarding" | "account_update";
  return_url?: string;
  refresh_url?: string;
}

export interface CreateAccountResponse {
  accountId: string;
  onboardingUrl?: string;
}

export interface AccountLinkResponse {
  url: string;
}

export const stripeConnectAPI = {
  // Create new Stripe Connect account
  createAccount: async (data: CreateConnectedAccountDto): Promise<CreateAccountResponse> => {
    try {
      const response = await HttpService.post(
        "api/v1/stripe/connect/accounts",
        data,
        headers,
        true
      );
      return response;
    } catch (error) {
      throw handleError(error);
    }
  },

  // Get account status
  getAccountStatus: async (accountId: string): Promise<AccountStatusResponse> => {
    try {
      const response = await HttpService.get(
        `api/v1/stripe/connect/accounts/${accountId}/status`,
        true,
        { "x-custom-lang": "en" }
      );
      return response;
    } catch (error) {
      throw handleError(error);
    }
  },

  // Create account link for onboarding
  createAccountLink: async (accountId: string, data: CreateAccountLinkDto): Promise<AccountLinkResponse> => {
    try {
      const response = await HttpService.post(
        `api/v1/stripe/connect/accounts/${accountId}/links`,
        data,
        headers,
        true
      );
      return response;
    } catch (error) {
      throw handleError(error);
    }
  },

  // Add test funds (test mode only)
  addTestFunds: async (accountId: string, amount: number, currency: string = "usd"): Promise<any> => {
    try {
      const response = await HttpService.post(
        "api/v1/stripe/connect/test-funds",
        { accountId, amount, currency },
        headers,
        true
      );
      return response;
    } catch (error) {
      throw handleError(error);
    }
  },
};

const handleError = (error: any) => {
  if (error?.data?.errors) {
    const errorMessage = Object.values(error.data.errors)[0] || "API Error";
    return new Error(Array.isArray(errorMessage) ? errorMessage[0] : errorMessage);
  }
  if (error?.data?.message) {
    return new Error(error.data.message);
  }
  return new Error("Network Error");
};